<template>
<transition name="slide-fade">
    <div class="dialog-view" v-show="visible">        
        <div class="rule-modal u-window">           
            <div class="dialog-content">              
                <div class="u-btn close" @click="destroyElement"></div>
                <div class="dialog-wrapper">
                    <div class="dialog-title t-rule"></div>

                    <div class="rules">
                        <vuescroll>
                            <div class="rule-text">
                                <p v-for="(item,index) in rule" :key="index">
                                    <em class="tag" :class="'t-' + (index + 1)" v-html="index+1"></em>
                                    <span class="label">{{ item.tag }}</span>
                                    <span v-html="item.text"></span>
                                </p>
                            </div>
                        </vuescroll>
                    </div>
                </div>
            </div>
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>    
</template>

<script>
import rule_dic from './text.js';

export default {
    name : 'evt_rule_modal',
    data : function () {
        return {
            visible : false,
            evt_time : '6月1日——7月3日',
            rule_text : rule_dic,
            type : 'evt',          
        }
    },
    mounted(){
        document.body.style.overflow = 'hidden';
    },
    computed :{
        rule (newVal){
            return this.rule_text[this.type]
        },        
    },    
    watch: {
        closed (newVal) {
            if (newVal) {
                this.visible = false
                this.destroyElement()
            }
        }
    },
    methods: {
        destroyElement () {
            document.body.style.overflow = ''; // 出现滚动条 
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },
    }    
}
</script>

<style lang="scss" scoped>

@include responseTo("desktop"){
    .rule-modal{
        transform: scale(0.7);
    }
}


    .rule-modal{
        position: relative;
        font-size: 22px;
        color: #5d2420;
        width: 667px;
        height: 810px;
        background-image: url(~@/assets/images/modal/bg-modal_lg.png);
    }


    .t-rule{
        width:429px;
        height: 64px;
        margin: 15px auto 25px;
        background-image: url(~@/assets/images/modal/title-rule.png);
    }

    .rules{
        width: 640px;
        color: #cbbda5;
    }

    .rule-modal .dialog-wrapper{
        /* padding: 20px 0 0; */
    }
    
    .rule-text{
        /* padding: 0 45px; */
    }

    .rule-text p{
        position: relative;
        line-height: 1.6;
        padding-left: 40px;
        margin-bottom: 25px;
    }

    .rule-modal p .tag{
        display: block;
        position: absolute;
        left: 0;
        top: 6px;
        width: 25px;
        height: 25px;
        /* text-align: center;
        line-height: 24px;
        color: #b83e2b;
        font-size: 18px;
        border: 1px solid #b83e2b;
        border-radius: 50%; */
        font-size: 0;
        color: transparent;

        @for $i from 1 through 6 {
            &.t-#{$i}{
                background-image: url(~@/assets/images/modal/idx/#{$i}.png);
            }
        }
    }

    .rule-modal .label{
        color: #ffd98b;
    }
</style>